import utils from '@eitje/utils'
import {FloatingFocusManager, useFloatingContext} from '../../../floating'
import {Layout} from '../../../layout'
import {FloatingSelectProvider, SelectProvider, useFloatingSelectContext, useSelectContext} from '../../context'
import {SelectHeader} from '../select_header'
import {SelectFooter} from '../select_footer'
import {SelectClearAll} from '../select_clear_all'
import {SelectToggleAll} from '../select_toggle_all'
import {SelectSearch} from '../select_search'
import {SelectItems} from '../select_items'

export const SelectLayout = ({width, maxWidth, height, className, title, footerButtons, emptyPlaceholderProps, ...rest}) => {
	const {refs, floatingStyles} = useFloatingContext()
	const {value, multiple} = useSelectContext()
	const {floatingLayoutProps} = useFloatingSelectContext()

	const classNames = utils.makeCns('select-layout', !!floatingLayoutProps && 'floating', className)

	return (
		<div onClick={e => e.stopPropagation()}>
			<Layout
				ref={refs?.setFloating}
				className={classNames}
				background="white"
				direction="vertical"
				gap={0}
				width={width}
				height={height}
				maxWidth={maxWidth}
				style={floatingStyles}
				{...floatingLayoutProps}
				{...rest}
			>
				<SelectHeader title={title} countSuffix={multiple && value.length} />
				<SelectSearch />
				<SelectClearAll />
				<SelectToggleAll />
				<SelectItems emptyPlaceholderProps={emptyPlaceholderProps} />
				<SelectFooter footerButtons={footerButtons} />
			</Layout>
		</div>
	)
}

export const FloatingSelectLayout = ({sharedProps, ...providerProps}) => {
	const {setIsOpen, isOpen} = useFloatingContext()

	if (!isOpen) return null

	return (
		<SelectProvider setIsOpen={setIsOpen} {...providerProps}>
			<FloatingSelectProvider>
				{/* An explicit focus order is required to prevent default active state in the first focusable element in the dropdonw */}
				<FloatingFocusManager order={['floating', 'content']}>
					<SelectLayout {...sharedProps} border borderRadius />
				</FloatingFocusManager>
			</FloatingSelectProvider>
		</SelectProvider>
	)
}
